/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Billing_Alltime_NoneInputs */



/**
* | output |
* | --- |
* | "No partner matches the search." |
*
* @param {Admin_Billing_Alltime_NoneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_billing_alltime_none = /** @type {((inputs?: Admin_Billing_Alltime_NoneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Billing_Alltime_NoneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Kein Partner passt zur Suche.")
	return /** @type {LocalizedString} */ ("No partner matches the search.")
});